import React, { useEffect } from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { RECAPTCHA_SITE_KEY } from '../../config/appConfig';

interface RecaptchaWrapperProps {
  children: React.ReactNode;
}

const RecaptchaWrapper: React.FC<RecaptchaWrapperProps> = ({ children }) => {
  // console.log('[RecaptchaWrapper] Rendering. Chiave:', RECAPTCHA_SITE_KEY);

  useEffect(() => {
    //console.log('%c[RecaptchaWrapper] Mounted.', 'color: green; font-weight: bold;');

    return () => {
      console.warn('%c[RecaptchaWrapper] UNMOUNTING!', 'color: red; font-weight: bold;');
    };
  }, []);

  if (!RECAPTCHA_SITE_KEY) {
    // console.error("[RecaptchaWrapper] ERRORE: RECAPTCHA_SITE_KEY non definito o vuoto!");
    return <>{children}</>;
  }

  return (
    <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITE_KEY}>
      {children}
    </GoogleReCaptchaProvider>
  );
};

export default RecaptchaWrapper;